import { render } from "./DriverOrders.vue?vue&type=template&id=338f86fe&scoped=true"
import script from "./DriverOrders.vue?vue&type=script&lang=js"
export * from "./DriverOrders.vue?vue&type=script&lang=js"

import "./DriverOrders.vue?vue&type=style&index=0&id=338f86fe&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338f86fe"]])

export default __exports__